// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".edit-area[data-v-18c37988]{display:flex;width:100%;justify-content:space-between}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/product/ProductShowPage.vue"],"names":[],"mappings":"AACA,4BACC,YAAA,CACA,UAAA,CACA,6BAAA","file":"ProductShowPage.vue","sourcesContent":["\n.edit-area {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-between;\n}\n"]}]);
// Exports
module.exports = exports;
